import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TicksToDateService {
  private epochTicks = 621355968000000000;
  private ticksPerMillisecond = 10000;
  private maxDateMilliseconds = 8640000000000000;
  constructor() {}

  public ticksToDate(ticks) {

    if(typeof ticks === 'string'){
      const notUtcDate = new Date(ticks);
      return new Date(
        Date.UTC(notUtcDate.getFullYear(),
          notUtcDate.getMonth(),
          notUtcDate.getDate(),
          notUtcDate.getHours(),
          notUtcDate.getMinutes())
      );
    }

    if (isNaN(ticks)) {
      return new Date();
    }
    let ticksSinceEpoch = ticks - this.epochTicks;
    let millisecondsSinceEpoch = ticksSinceEpoch / this.ticksPerMillisecond;

    if (millisecondsSinceEpoch > this.maxDateMilliseconds) {
      return new Date(8640000000000000);
    }

    const timeWithOffset = new Date(millisecondsSinceEpoch);
    const offsetInMinutes = timeWithOffset.getTimezoneOffset();

    return new Date( timeWithOffset.getTime() + offsetInMinutes * 60000);
  }
}
